import React from 'react'

import { Toolbar } from 'primereact/toolbar'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

// wrappers for prime react form fields
import FieldInputText from '../common/FieldInputText'
import FieldCheckbox from '../common/FieldCheckbox'
import FieldPassword from '../common/FieldPassword'

import '../../css/user-details.css'

const UserDetailsDialogFooter = ({ submitForm }) => {
  return (
    <React.Fragment>
      <Toolbar>
        <div className="p-toolbar-group-left">
          <Button label="Save" icon="pi pi-check" onClick={submitForm} />
        </div>
      </Toolbar>
    </React.Fragment>
  )
}

const UserDetails = ({ currentUser, isAdd, submitForm, resetForm, isDisplayingDialog, closeUserDetails }) => {
  let validationRules = currentUser.ValidationRules ? currentUser.ValidationRules.$values : []
  let dialogFooter = <UserDetailsDialogFooter submitForm={submitForm} />
  return (
    <Dialog visible={isDisplayingDialog} header="User Details" modal={true} footer={dialogFooter}
      onHide={() => { closeUserDetails(resetForm) }}>
      <div className="p-grid user-details">
        <div className="p-col-12">
          <FieldInputText field={"Email"} label={"Email"}  aria-label="Email" tabindex="0" validationRules={validationRules} showAsTextOnly={false} />
        </div>
        <div className="p-col-12">
          <FieldInputText field={"GivenNames"} label={"First Name"} aria-label="First Name" tabindex="0"  validationRules={validationRules} showAsTextOnly={false} />
        </div>
        <div className="p-col-12">
          <FieldInputText field={"FamilyName"} label={"Last Name"} aria-label="Last Name" tabindex="0"  validationRules={validationRules} showAsTextOnly={false} />
        </div>
        <div className="p-col-12">
          <FieldInputText field={"Department"} label={"Department"} aria-label="Department" tabindex="0"  validationRules={validationRules} showAsTextOnly={false} />
        </div>
        <div className="p-col-6">
          <FieldPassword field={"Password"} label={"Password"} aria-label="Password" tabindex="0"  validationRules={validationRules} />
        </div>
        <div className="p-col-6">
          <FieldPassword field={"ConfirmPassword"} label={"Confirm Password"} aria-label="Confirm Password" tabindex="0"  validationRules={validationRules} />
        </div>
        {isAdd === false && <div className="p-col-12">
          <FieldCheckbox field={"IsActive"} label={"Is Active"} validationRules={validationRules} showAsTextOnly={false} />
        </div>}
      </div>
    </Dialog>
  )
}

export default UserDetails;


// WEBPACK FOOTER //
// ./src/components/user/user-details.js